import { Button, Collapse, Nav, NavbarToggler } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import { useState } from "react";

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const lastPath = location.pathname;
  const toggle = () => {
    setIsOpen(!isOpen);
    document.documentElement.classList.toggle("nav-open");
    document.getElementById("nav").classList.toggle("toggled");
  };

  return (
    <div className="container position-sticky z-index-sticky top-0">
      <div className="row">
        <div className="col-12">
          <Nav className="navbar navbar-expand-lg blur blur-rounded top-0 z-index-3 shadow position-absolute my-3 py-2 start-0 end-0 mx-4">
            <div className="container-fluid px-0">
              <Link
                className="navbar-brand font-weight-bolder ms-3"
                to={"/"}
                style={{ fontSize: "1rem" }}
              >
                International Workshop - SM&E
              </Link>
              <NavbarToggler
                className="shadow-none ms-2 d-none"
                onClick={toggle}
                id={"nav"}
              >
                <span className="navbar-toggler-icon mt-2">
                  <span className="navbar-toggler-bar bar1" />
                  <span className="navbar-toggler-bar bar2" />
                  <span className="navbar-toggler-bar bar3" />
                </span>
              </NavbarToggler>
              <Collapse
                isOpen={isOpen}
                className="navbar-collapse pt-3 pb-2 py-lg-0 w-100"
                navbar
              >
                <ul className="navbar-nav navbar-nav-hover ms-lg-12 ps-lg-5 w-100">
                  {lastPath === "/" && (
                    <>
                      <li className="nav-item ms-3 ms-lg-auto">
                        <Link
                          to={"/sign-up"}
                          className="btn btn-sm  bg-white  btn-round mb-0 me-1 mt-2 mt-md-0"
                        >
                          Click Here To Apply
                        </Link>
                      </li>
                      <li className="nav-item my-auto ms-3 ms-lg-0 me-3">
                        <Button
                          onClick={() => {
                            window.location.href = "https://smeproje.web.app";
                          }}
                          className="btn btn-sm bg-gradient-dark btn-round mb-0 me-1 mt-2 mt-md-0"
                        >
                          Login
                        </Button>
                      </li>
                    </>
                  )}

                  {lastPath === "/login" && (
                    <li className="nav-item my-auto ms-auto me-3">
                      <Link
                        to={"/sign-up"}
                        className="btn btn-sm  bg-gradient-dark  btn-round mb-0 me-1 mt-2 mt-md-0"
                      >
                        Sign Up
                      </Link>
                    </li>
                  )}
                  {lastPath === "/sign-up" && (
                    <li className="nav-item my-auto ms-auto me-3">
                      <a
                        href={"https://smeproje.web.app"}
                        className="btn btn-sm  bg-gradient-dark  btn-round mb-0 me-1 mt-2 mt-md-0"
                      >
                        Login
                      </a>
                    </li>
                  )}
                </ul>
              </Collapse>
            </div>
          </Nav>
        </div>
      </div>
    </div>
  );
};

export default NavBar;
